// extracted by mini-css-extract-plugin
module.exports = {"container":"_1oHqe5kL9TZ36ptWxFsPYR","visible":"_3OV_pVwkq99nvCvhagMQfi","cancelBtn":"_39fXOHEVRN3v5hjRT_YfbW","icon":"NgNqD8JPcBKNTzt1gv69e","saveBtn":"_3sA72nFJiwzD27ijtBDLQN"};